import { axiosCms } from 'Axios.js';
import { authToken } from '../utility';
import * as actionTypes from './actionTypes';

const fetchRoomsStart = () => ({ type: actionTypes.FETCH_ROOMS_START });
const fetchRoomsEnd = data => ({ type: actionTypes.FETCH_ROOMS_END, data });

const addRoomStart = () => ({ type: actionTypes.ADD_ROOM_START });
const addRoomServer = () => ({ type: actionTypes.ADD_ROOM_SERVER });
const addRoomStore = () => ({ type: actionTypes.ADD_ROOM_STORE });

const updateRoomStart = () => ({ type: actionTypes.UPDATE_ROOM_START });
const updateRoomEnd = () => ({ type: actionTypes.UPDATE_ROOM_END });

const deleteRoomStart = () => ({ type: actionTypes.DELETE_ROOM_START });
const deleteRoomStore = () => ({ type: actionTypes.DELETE_ROOM_STORE });
const deleteRoomServer = () => ({ type: actionTypes.DELETE_ROOM_SERVER });

export const fetchRooms = () => dispatch => {
  dispatch(fetchRoomsStart());
  axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());
  return axiosCms
    .get('/rooms')
    .then(response => {
      const { data } = response;
      return dispatch(fetchRoomsEnd(data));
    })
    .catch(err => {
      console.error('#fetchRooms', err);
      return Promise.reject(err);
    });
};

export const addRooms = () => dispatch => Promise.resolve(dispatch(addRoomStore()));

export const addRoomAsync = value => dispatch => {
  dispatch(addRoomStart());
  axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

  const { name } = value;
  return axiosCms
    .post('/rooms', { name: name })
    .then(resp => {
      dispatch(addRoomServer());
      dispatch(fetchRooms());
      return 'completed';
    })
    .catch(err => {
      console.error('#addRoomAsync', err);
      return Promise.reject(err);
    });
};

export const updateRoom = value => dispatch => {
  dispatch(updateRoomStart());
  axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

  const { id, name } = value;
  return axiosCms
    .put('/rooms/' + id, { name: name })
    .then(resp => {
      console.log(resp);
      dispatch(updateRoomEnd());
      dispatch(fetchRooms());
      return 'completed';
    })
    .catch(err => {
      console.error('#updateRoom', err);
      return Promise.reject(err);
    });
};

export const deleteRoom = () => dispatch => Promise.resolve(dispatch(deleteRoomStore()));

export const deleteRoomAsync = value => dispatch => {
  dispatch(deleteRoomStart());
  axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

  const { id } = value;
  return axiosCms
    .delete('/rooms/' + id)
    .then(resp => {
      dispatch(deleteRoomServer());
      dispatch(fetchRooms());
      return 'complete';
    })
    .catch(err => {
      console.error('#deleteRoomAsync', err);
      return Promise.reject(err);
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/rooms.js